export const TOTAL_CLEAN_ENERGY = 2400;
export const INITIAL_CLEAN_ENERGY = Math.floor(TOTAL_CLEAN_ENERGY / 2);
// export const INITIAL_CLEAN_ENERGY = 2200;
export const GAME_COUNTDOWN_TIMER_INTERVAL = 5000;
export const DIRTY_ENERGY_PERCENTAGE_FOR_PEAK_LOAD_PANIC = 80;
export const HUMAN_PLAYER_DELAY = 3000;
export const SHUFFLE_TIME = 3000;
export const CARD_DISTRIBUTION_TIME = 2000;
export const DELAY_ON_COMPUTER_CARD_DRAW = false;
export const PLAYER_DEFAULT_AGE = 15;
export const PLAYER_ENERGY_CARD_WRONG_ANS_CUT_TIME = 0;